import type { HeroIn, HeroParsed } from '../@types/Hero';

class Hero {
  static parse = ({
    callToActionTitle,
    callToActionUrl,
    callToActionTheme,
    callToActionTitleSecondary,
    callToActionUrlSecondary,
    callToActionThemeSecondary,
    heading,
    imageDesktop,
    imageMobile,
    premable,
    contentAlignment,
    video,
  }: HeroIn): HeroParsed => {
    const textAlignRight = (contentAlignment || '').includes('right');

    return {
      callToActionTitle,
      callToActionUrl,
      callToActionTheme,
      callToActionTitleSecondary,
      callToActionUrlSecondary,
      callToActionThemeSecondary,
      heading,
      imageDesktop,
      imageMobile,
      premable,
      textAlignRight,
      video,
    };
  };
}

export default Hero;
